import { Box, Typography } from "@mui/material";

// Subject shown below the sender name on an original message. Rendered only
// when the message actually has a subject.
const Subject = ({ subject }) => {
  if (!subject) return null;

  return (
    <Box sx={{ marginTop: 0.5 }}>
      <Typography component="div" fontSize={14} sx={{ fontWeight: "bold" }}>
        {subject}
      </Typography>
    </Box>
  );
};

export default Subject;
